import { Box } from '@mui/material'
import { SchedulerTabsProps } from './Scheduler.types'
import {
  useScheduleProductionRequirements,
  useSchedulerTableHandlers,
} from './Scheduler.data'
import { SchedulerSteriliserRoutingTable } from './SchedulerSteriliserRouting.muiTable'
import { ManagedSourceBanner } from './ManagedSourceBanner'
import { SECTIONS } from './SchedulerInput.sections'

export const ScheduleSteriliserRouting = ({
  schedulerId,
  iteration,
  readOnly = false,
  onOpenRule,
}: SchedulerTabsProps & {
  readOnly?: boolean
  onOpenRule?: (tab: string) => void
}) => {
  const API = 'steriliser-routing'
  const { data: responseData = { data: [], predicate: undefined }, isLoading } =
    useScheduleProductionRequirements(schedulerId, API, iteration)
  const { data = [], predicate } = responseData

  const {
    updateTableData,
    uploadScheduleData,
    deleteTableData,
    isSaving,
    isUploading,
    isDeleting,
    updateRowsStatus,
  } = useSchedulerTableHandlers(schedulerId, API, iteration)

  return (
    <Box sx={{ height: 'calc(100vh - 240px)', minHeight: 400 }}>
      {readOnly && onOpenRule && (
        <ManagedSourceBanner
          label="Steriliser"
          onOpen={() => onOpenRule(SECTIONS.RULES_STERILISER)}
        />
      )}
      <SchedulerSteriliserRoutingTable
        data={data}
        isLoading={isLoading}
        updateTableData={updateTableData}
        uploadScheduleData={uploadScheduleData}
        isUploading={isUploading}
        isSaving={isSaving}
        updateRowsStatus={updateRowsStatus}
        predicate={predicate}
        onDeleteRows={deleteTableData}
        isDeleting={isDeleting}
        readOnly={readOnly}
      />
    </Box>
  )
}
